export function BrandLockup({ compact = false, nameHref, onNavigate, schoolHref }) {
  const brandName = (
    <>
      Il Consulente <em>AI</em>
    </>
  );
  const schoolName = (
    <>
      un percorso online <strong>XAISchool</strong>
    </>
  );

  return (
    <span className={compact ? "brand-lockup brand-lockup--compact" : "brand-lockup"}>
      {nameHref ? (
        <a
          aria-label="Il Consulente AI, torna all’inizio"
          className="brand-lockup__name brand-lockup__home"
          href={nameHref}
          onClick={onNavigate}
        >
          {brandName}
        </a>
      ) : (
        <span className="brand-lockup__name">{brandName}</span>
      )}
      <span className="brand-lockup__divider" aria-hidden="true" />
      {schoolHref ? (
        <a
          aria-label="Esplora gli altri corsi su XAISchool"
          className="brand-lockup__school brand-lockup__school-link"
          href={schoolHref}
          onClick={onNavigate}
          rel="noreferrer"
          target="_blank"
        >
          {schoolName}
        </a>
      ) : (
        <span className="brand-lockup__school">{schoolName}</span>
      )}
    </span>
  );
}
